// @ts-nocheck

(() => {
  'use strict';
  const TAG = '[AttentiveBootstrap]';
  const QUEUE = [];

  const stubTrigger = function (...args) {
    QUEUE.push(args);
  };

  if (!window.__attentive) {
    window.__attentive = { _isStub: true, trigger: stubTrigger };
  } else if (typeof window.__attentive.trigger !== 'function') {
    window.__attentive.trigger = stubTrigger;
    window.__attentive._isStub = true;
  } else {
    // Real SDK already present — fire the ready event so any listeners that
    // attach later (e.g. section scripts) still resolve.
    window.dispatchEvent(new CustomEvent('attentive:ready', { detail: { elapsedMs: 0 } }));
    return;
  }

  const startedAt = performance.now();
  const POLL = 200;
  const TIMEOUT = 30000;
  const watchdog = setInterval(() => {
    const cur = window.__attentive;
    const elapsed = performance.now() - startedAt;
    const ready = cur && typeof cur.trigger === 'function' && cur.trigger !== stubTrigger;

    if (ready) {
      while (QUEUE.length > 0) {
        const args = QUEUE.shift();
        try {
          cur.trigger(...args);
        } catch (err) {
          console.warn(TAG, 'replay failed for', args, err);
        }
      }
      window.dispatchEvent(new CustomEvent('attentive:ready', { detail: { elapsedMs: Math.round(elapsed) } }));
      clearInterval(watchdog);
      return;
    }

    if (elapsed >= TIMEOUT) {
      console.warn(
        TAG,
        `Attentive SDK never loaded after ${Math.round(elapsed)}ms (likely blocked by an ad-blocker / privacy extension). ` +
          `Newsletter CTA will remain hidden. ${QUEUE.length} queued call(s) discarded.`
      );
      clearInterval(watchdog);
    }
  }, POLL);
})();

(() => {
  'use strict';

  const isSearchTemplate = () => {
    const t = window.Theme && window.Theme.template;
    return t && t.name === 'search';
  };

  const loadRebuy = () => {
    const shop = (window.Shopify && window.Shopify.shop) || window.location.hostname;
    const s = document.createElement('script');
    s.src = `https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=${shop}`;
    document.body.appendChild(s);
  };

  if (isSearchTemplate()) {
    loadRebuy();
  } else if ('requestIdleCallback' in window) {
    requestIdleCallback(loadRebuy, { timeout: 8000 });
  } else {
    window.addEventListener('load', () => setTimeout(loadRebuy, 2000), { once: true });
  }

  let _Rebuy;
  const patchSmartCart = (obj) => {
    if (obj && typeof obj === 'object' && !obj.deliveryRange) {
      obj.deliveryRange = () => '';
    }
  };
  if (window.Rebuy) {
    _Rebuy = window.Rebuy;
    if (_Rebuy.SmartCart) patchSmartCart(_Rebuy.SmartCart);
  }
  Object.defineProperty(window, 'Rebuy', {
    configurable: true,
    enumerable: true,
    get: () => _Rebuy,
    set: (val) => {
      _Rebuy = val;
      if (val && val.SmartCart) {
        patchSmartCart(val.SmartCart);
      } else if (val) {
        let _sc;
        Object.defineProperty(val, 'SmartCart', {
          configurable: true,
          enumerable: true,
          get: () => _sc,
          set: (scVal) => {
            _sc = scVal;
            patchSmartCart(scVal);
          },
        });
      }
    },
  });
})();

(() => {
  'use strict';

  const ACSB_TRIGGER_CSS =
    '.trigger-button, button[part="acsb-trigger"] {' +
    'width: 40px !important; height: 40px !important;' +
    'min-width: 40px !important; min-height: 40px !important;' +
    'inline-size: 40px !important; block-size: 40px !important;' +
    '}' +
    '@media screen and (max-width: 767px) {' +
    '.trigger-button, button[part="acsb-trigger"], [data-testid="acsb-trigger"] {' +
    'display: none !important;' +
    '}' +
    '}';

  const initAccessibility = () => {
    try {
      const s = document.createElement('script');
      s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
      s.async = true;
      s.onload = () => {
        if (typeof acsbJS !== 'undefined') {
          acsbJS.init({
            statementLink: '',
            footerHtml: '',
            hideMobile: false,
            hideTrigger: false,
            language: 'en',
            position: 'right',
            leadColor: '#146ff8',
            triggerColor: '#146ff8',
            triggerRadius: 0,
            triggerPositionX: 'right',
            triggerPositionY: 'top',
            triggerIcon: 'people',
            triggerSize: 'medium',
            triggerOffsetX: 0,
            triggerOffsetY: 0,
            mobile: {
              triggerSize: 'small',
              triggerPositionX: 'right',
              triggerPositionY: 'top',
              triggerOffsetX: 0,
              triggerOffsetY: 0,
              triggerRadius: 0,
            },
          });
        }
      };
      s.onerror = () => console.warn('Accessibility script failed to load');
      (document.body || document.querySelector('head')).appendChild(s);
    } catch (error) {
      console.error('Error initializing accessibility:', error);
    }
  };

  const injectAcsbStyle = (root) => {
    if (!root || root.__acsbSizeInjected) return;
    try {
      const style = document.createElement('style');
      style.setAttribute('data-injected', 'acsb-trigger-size');
      style.textContent = ACSB_TRIGGER_CSS;
      root.insertBefore(style, root.firstChild);
      root.__acsbSizeInjected = true;
    } catch (_) {}
  };

  const scanForAcsbShadowRoot = () => {
    const els = document.querySelectorAll('*');
    for (const el of els) {
      if (el.shadowRoot && !el.shadowRoot.__acsbSizeInjected) {
        if (el.shadowRoot.querySelector('[part="acsb-trigger"], [data-testid="acsb-trigger"]')) {
          injectAcsbStyle(el.shadowRoot);
        }
      }
    }
  };

  const acsbObserver = new MutationObserver(scanForAcsbShadowRoot);
  const startAcsbObserver = () => {
    acsbObserver.observe(document.documentElement, { childList: true, subtree: true });
    scanForAcsbShadowRoot();
  };
  if (document.body) {
    startAcsbObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startAcsbObserver, { once: true });
  }
  setTimeout(() => acsbObserver.disconnect(), 120000);

  if ('requestIdleCallback' in window) {
    requestIdleCallback(initAccessibility, { timeout: 10000 });
  } else {
    window.addEventListener('load', () => setTimeout(initAccessibility, 4000), { once: true });
  }
})();

(() => {
  const overlay = document.getElementById('rebuy-search-overlay');
  if (!overlay) return;
  const checkPanel = () => {
    const container = document.querySelector('.rebuy-quick-view-dropdown__container.visible, .rebuy-quick-view-flyout__container.visible');
    overlay.style.display = container ? 'block' : 'none';
  };
  new MutationObserver(checkPanel).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
  overlay.addEventListener('click', () => { overlay.style.display = 'none'; });
})();

(() => {
  'use strict';

  const collectionCache = Object.create(null);
  const inflightFetches = Object.create(null);
  const fetchQueue = [];
  let activeRequests = 0;
  const MAX_CONCURRENT_FETCHES = 2;
  const FETCH_INTERVAL_MS = 120;

  const normalizeTags = (rawTags) => {
    if (!rawTags) return [];
    if (Array.isArray(rawTags)) return rawTags;
    if (typeof rawTags === 'string') return rawTags.split(/,\s*/);
    return [];
  };

  const getCollectionFromTags = (tags) => {
    if (!tags || !tags.length) return '';
    for (const tag of tags) {
      if (!tag || tag.indexOf('::') === -1) continue;
      const parts = tag.split('::');
      if ((parts[0] || '').trim().toLowerCase() === 'collection') {
        return (parts[1] || '').trim().replace(/\s*\|\s*rx$/i, '');
      }
    }
    return '';
  };

  const pumpFetchQueue = () => {
    while (activeRequests < MAX_CONCURRENT_FETCHES && fetchQueue.length > 0) {
      const task = fetchQueue.shift();
      activeRequests++;
      fetch(`/products/${task.handle}.json`, { credentials: 'same-origin' })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`);
          return r.json();
        })
        .then((data) => normalizeTags(data && data.product && data.product.tags))
        .then((tags) => {
          const collection = getCollectionFromTags(tags);
          collectionCache[task.handle] = collection;
          task.resolve(collection);
        })
        .catch(() => {
          collectionCache[task.handle] = '';
          task.resolve('');
        })
        .then(() => {
          delete inflightFetches[task.handle];
          setTimeout(() => {
            activeRequests--;
            pumpFetchQueue();
          }, FETCH_INTERVAL_MS);
        });
    }
  };

  const fetchCollectionForHandle = (handle) => {
    if (handle in collectionCache) return Promise.resolve(collectionCache[handle]);
    if (inflightFetches[handle]) return inflightFetches[handle];
    const promise = new Promise((resolve) => {
      fetchQueue.push({ handle, resolve });
      pumpFetchQueue();
    });
    inflightFetches[handle] = promise;
    return promise;
  };

  const ensureCollectionForCard = (card, collection, handle) => {
    if (!card || !card.isConnected) return;
    const existing = card.querySelector('.rebuy-product-collection');

    if (!collection) {
      if (existing) existing.remove();
      return;
    }

    if (existing) {
      if (existing.dataset.rebuyHandle === handle && existing.textContent === collection) return;
      existing.dataset.rebuyHandle = handle;
      existing.textContent = collection;
      return;
    }

    const titleEl = card.querySelector('.rebuy-product-title');
    if (!titleEl) return;
    const p = document.createElement('p');
    p.className = 'rebuy-product-collection';
    p.dataset.rebuyHandle = handle;
    p.textContent = collection;
    titleEl.insertAdjacentElement('afterend', p);
  };

  const resolveTagsFromDataAttr = (card) => {
    const productEl = card.closest('[data-rebuy-product]') || card;
    try {
      const dataAttr = productEl.getAttribute('data-rebuy-product');
      if (dataAttr) {
        const data = JSON.parse(dataAttr);
        return normalizeTags(data.tags);
      }
    } catch (_) {}
    return null;
  };

  const getHandle = (card) => {
    const anchors = card.querySelectorAll('a[href*="_rdiscovery-handle="]');
    for (const a of anchors) {
      const match = (a.getAttribute('href') || '').match(/[?&]_rdiscovery-handle=([^&#]+)/);
      if (match) return decodeURIComponent(match[1]);
    }
    const titleLink = card.querySelector('.rebuy-product-title');
    if (!titleLink) return '';
    const href = titleLink.getAttribute('href') || '';
    return href.split('/products/').pop().split('?')[0].split('#')[0];
  };

  const findInProductArray = (arr, handle) => {
    if (!arr || !arr.length) return null;
    for (const item of arr) {
      if (!item || typeof item !== 'object') continue;
      if (item.handle === handle && item.tags) return normalizeTags(item.tags);
      if (item.products && item.products.length) {
        const inner = findInProductArray(item.products, handle);
        if (inner) return inner;
      }
    }
    return null;
  };

  const resolveTagsFromRebuyState = (handle) => {
    const SS = window.Rebuy && window.Rebuy.SmartSearch;
    const $data = SS && SS.quickView && SS.quickView.view && SS.quickView.view.$data;
    if (!$data) return null;
    for (const key of ['products', 'collections', 'content']) {
      const found = findInProductArray($data[key], handle);
      if (found) return found;
    }
    return null;
  };

  const processCard = (card) => {
    if (!card || !card.isConnected) return;

    const handle = getHandle(card);
    if (!handle) {
      // Card has no resolvable product — drop any stale label.
      const stale = card.querySelector('.rebuy-product-collection');
      if (stale) stale.remove();
      return;
    }

    // If we already labeled this exact handle on this exact card, skip work.
    const existing = card.querySelector('.rebuy-product-collection');
    if (existing && existing.dataset.rebuyHandle === handle) return;

    const tags = resolveTagsFromDataAttr(card);
    if (tags && tags.length) {
      ensureCollectionForCard(card, getCollectionFromTags(tags), handle);
      return;
    }

    if (handle in collectionCache) {
      ensureCollectionForCard(card, collectionCache[handle], handle);
      return;
    }

    const stateTags = resolveTagsFromRebuyState(handle);
    if (stateTags && stateTags.length) {
      const collection = getCollectionFromTags(stateTags);
      collectionCache[handle] = collection;
      ensureCollectionForCard(card, collection, handle);
      return;
    }

    if (existing) existing.remove();

    fetchCollectionForHandle(handle).then((collectionName) => {
      if (!card.isConnected) return;
      if (getHandle(card) !== handle) return;
      ensureCollectionForCard(card, collectionName, handle);
    });
  };

  const processQuickViewCards = (root) => {
    const scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('.rebuy-quick-view__product').forEach(processCard);
    if (root && root.classList && root.classList.contains('rebuy-quick-view__product')) {
      processCard(root);
    }
  };

  const runInjection = (root) => {
    processQuickViewCards(root);
    requestAnimationFrame(() => processQuickViewCards(root));
  };

  window.__blendersInjectCollectionTitles = runInjection;

  const attachVueWatchers = () => {
    const SS = window.Rebuy && window.Rebuy.SmartSearch;
    const view = SS && SS.quickView && SS.quickView.view;
    if (!view || typeof view.$watch !== 'function') return false;
    if (view.__blendersWatchersAttached) return true;
    view.__blendersWatchersAttached = true;

    const flush = () => {
      view.$nextTick(() => {
        runInjection();
        setTimeout(runInjection, 80);
        setTimeout(runInjection, 250);
        setTimeout(runInjection, 600);
      });
    };

    view.$watch('isQuickViewOpen', (isOpen) => { if (isOpen) flush(); });
    view.$watch('products', flush, { deep: false });
    view.$watch('content', flush, { deep: false });
    view.$watch('collections', flush, { deep: false });

    view.$watch('quickViewSearchLoading', (isLoading) => {
      document.body.classList.toggle('blenders-rebuy-loading', !!isLoading);
      if (!isLoading) flush();
    });
    if (view.quickViewSearchLoading) {
      document.body.classList.add('blenders-rebuy-loading');
    }

    if (view.isQuickViewOpen) flush();
    return true;
  };

  if (!attachVueWatchers()) {
    let attempts = 0;
    const poll = setInterval(() => {
      attempts++;
      if (attachVueWatchers() || attempts >= 50) clearInterval(poll);
    }, 200);
  }

  let scanScheduled = false;
  const scheduleFullScan = () => {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(() => {
      scanScheduled = false;
      document.querySelectorAll('.rebuy-quick-view__product').forEach(processCard);
    });
  };

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (!n || n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains('rebuy-product-collection')) continue;
        scheduleFullScan();
        break;
      }
      for (const r of m.removedNodes) {
        if (!r || r.nodeType !== 1) continue;
        if (r.classList && r.classList.contains('rebuy-product-collection')) {
          scheduleFullScan();
          break;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  runInjection();
})();
